import { sanityClient } from "@/lib/sanity";

export const HOMEPAGE_QUERY = `*[_type == "homepage"][0]{
  _updatedAt, seo,
  heroTitle, heroSubtitle, heroCaption,
  heroCTAs{
    ios{ visible, wording, url },
    android{ visible, wording, url },
    joinWaitlist{ visible, placeholder, wording }
  },
  heroImage,
  heroHasLocalizedImage, heroLocalizedImage,
  sections[]{ _key, eyebrow, title, description, cta, image, hasLocalizedImage, localizedImage },
  testimonials[]{ _key, name, quote, avatar },
  "learnMorePages": *[_type == "learnMorePage"]{ "en": slug.en.current, "fr": slug.fr.current }
}`;

// Uses the shared client's CDN (useCdn: true) — ~60s freshness, load-safe.
export const fetchHomepage = () => sanityClient.fetch<any>(HOMEPAGE_QUERY);
